/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'CATHÉDRALE DE VALENCE',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(Downloading)',
        download:'Downloading',
        errorDownload: '',
        cancelDownload: '',
        initDownload: 'Merci de patienter pendant le chargement des fichiers audio',
        endDownload: 'Fichiers télechargés. Bonne visite!',
        retry: 'Reintentar',
        noConnection: '',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Bienvenue',
                author: 'Veuillez utiliser des écouteurs',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Saint Sébastien',
                author: 'Bas de la nef',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Saint Pierre Apôtre',
                author: 'Nef latérale droite',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Saint François de Borja',
                author: 'Nef latérale droite',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'La fenêtre en biais',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Maître-autel',
                author: 'Grande Chapelle',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Anges musiciens',
                author: 'Grande Chapelle',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Tour-lanterne',
                author: 'Croisée',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Porte de l\'Almoina',
                author: 'Bras droit du transept',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Déambulatoire + Orgue',
                author: 'Déambulatoire',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Résurrection',
                author: 'Chapelles du déambulatoire',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Christ de la Bonne Mort',
                author: 'Chapelles du déambulatoire',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Vierge de la Chaise + St Jacques',
                author: 'Chapelles du déambulatoire',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'Saint Denis',
                author: 'Chapelles du déambulatoire',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Porte des Apôtres',
                author: 'Bras gauche du transept',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Suite de la visite',
                author: 'Nef latérale gauche',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Ostensoir',
                author: 'Musée : rez-de-chaussée',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Mauvais Larron + Adoration',
                author: 'Musée : rez-de-chaussée',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Maquettes',
                author: 'Musée : deuxième étage',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apôtres',
                author: 'Musée : deuxième étage',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Saint Thomas + Dormition',
                author: 'Musée : deuxième étage',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Reliquaire',
                author: 'Musée : deuxième étage',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Dérision du Christ',
                author: 'Musée : deuxième étage',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Couloir + Art baroque',
                author: 'Musée : deuxième étage',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Fouilles archéologiques',
                author: 'Musée : sous-sol',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Livres de chœur + La Cène',
                author: 'Musée : rez-de-chaussée',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'Le Saint Chalice',
                author: 'Chapelle du Saint Chalice',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Chapelle du Saint Chalice',
                author: 'Chapelle du Saint Chalice',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'Le Micalet',
                author: 'Bas de la nef',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Crédits',
                isCredits:true,
                author: '',
                description: 'Trama Media pour la Cathédrale de Valence.<br><br>© Cathédrale de Valence.<br><br>Tous droits réservés.<br><br>',
                audio: '',
                idCreditImage: 30,
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/français.js